/* eslint-disable @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirect() */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { AcceptLegal } from "@/pages/Auth/AcceptLegal";
import { legalService } from "@/api/legal";
import { requireAuth } from "@/utils/routeGuards";

export const Route = createFileRoute("/auth/accept-legal")({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === "string" ? search.from : undefined,
  }),
  beforeLoad: async ({ location }) => {
    requireAuth(location);

    const { data } = await legalService.getStatus();
    if (data?.data.all_required_accepted) {
      throw redirect({ to: "/app" });
    }
  },
  component: AcceptLegal,
});
